const apiUrl = import.meta.env.VITE_API_URL_V2;

function img(url: string) {
    if(!url) return '';
    // Asegurar que apiUrl no termine con / y url no comience con /
    const cleanApiUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
    const cleanUrl = url.startsWith('/') ? url.slice(1) : url;
    
    return `${cleanApiUrl}/${cleanUrl}`;
}

export { img };
